import { PlusIcon, TagIcon, TruckIcon } from "@heroicons/react/24/outline";

type NoShipmentCardProps = {
  title: string;
};

export default function NoShipmentCard({ title }: NoShipmentCardProps) {
  return (
    <section className="overflow-hidden rounded-xl border border-gray-100 bg-white">
      <div className="flex items-center justify-between gap-3 border-b border-gray-100 px-4 py-4.5 md:px-5">
        <h2 className="flex items-center gap-2 text-sm font-medium text-gray-950 md:text-base">
          <TruckIcon className="size-5 text-blue-600" />
          {title}
        </h2>
      </div>

      <div className="flex flex-col gap-4 px-4 py-5 md:px-5">
        <p className="text-center text-xs font-medium text-gray-500 md:text-sm">
          No shipping label or tracking ID has been added yet.
        </p>

        <div className="flex flex-col-reverse gap-3 sm:flex-row">
          <button
            type="button"
            className="flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-lg bg-gray-100 px-5 py-2.5 text-sm font-medium text-gray-950 transition-colors hover:bg-gray-200"
          >
            <PlusIcon className="size-4" />
            Add Tracking ID
          </button>

          <button
            type="button"
            className="flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-700"
          >
            <TagIcon className="size-4" />
            Buy Shipping Label
          </button>
        </div>
      </div>
    </section>
  );
}
